var React = require('react');

function HealthWorker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M34,38v6H0v-6c0-6,3.5-11.4,9-13.7V31H8l0,0c-2.2,0-4,1.8-4,4v6c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1s-0.4-1-1-1\n\tH6v-5c0-1.1,0.9-2,2-2h4l0,0c1.1,0,2,0.9,2,2v5h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h2c0.6,0,1-0.4,1-1v-6l0,0c0-2.2-1.8-4-4-4h-1v-7.4\n\tc1.3-0.4,2.6-0.6,4-0.6h4c1.4,0,2.7,0.2,4,0.6v7.6c-0.9,0.3-1.5,1-1.8,1.8c-0.6,1.6,0.3,3.3,1.8,3.8s3.3-0.3,3.8-1.8\n\ts-0.3-3.3-1.8-3.8v-6.9C30.5,26.6,34,32,34,38z M17,20c5.5,0,10-4.5,10-10S22.5,0,17,0S7,4.5,7,10S11.5,20,17,20z"}));
}

HealthWorker.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 34 44","style":{"enableBackground":"new 0 0 34 44"},"xmlSpace":"preserve"};

module.exports = HealthWorker;

HealthWorker.default = HealthWorker;
